import { Box, Card, CardContent, Typography } from "@mui/material";
// import clientImage from "../../../../public/icons/Users.png";
// import BatukLogo from "../../../../public/img/BatukLogo.png";
import { useSelector } from "react-redux";

export default function NoDashboardPermission() {
  const roleResponse = useSelector((state) => state.login.login.role);
  return (
    <div>
      <Card
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#fafafa !important",
          // width:"-50%",import { useSelector } from 'react-redux';

          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pt: "10px",
            mt: 10,
          }}
        >
          <img
            // src={BatukLogo}
            src={"/img/BatukLogo.png"}
            alt="logo"
            style={{
              maxHeight: "150px",
              maxWidth: "150px",
              backgroundColor: "#4a2a7d",
            }}
          />
        </Box>
        <Typography variant="h3" color="#4a2a7d" sx={{ mt: 2 }}>
          Welcome to Batuk
        </Typography>

        {/* <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pt: "10px",
            mt:5
          }}
        >
          <img
            src={clientImage}
            alt="logo"
            style={{ maxHeight: "80px", maxWidth: "80px", color: "" ,}}
          />
        </Box> */}
        <CardContent sx={{ textAlign: "center", p: "0px" }}>
          <Typography
            variant="h4"
            component="div"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              mt: 4,
              mb: 8, // or use line-clamp to restrict to a fixed number of lines
            }}
          >
            {roleResponse?.name || "User"}
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
}
